import React from 'react';
import "./Settings.css";
import { NavLink, Routes, Route, useSearchParams } from 'react-router-dom';

import { MdOutlineSecurity } from "react-icons/md";
import { AiOutlineControl } from "react-icons/ai";
import { RiAccountCircleLine } from "react-icons/ri";
import { MdBrush } from "react-icons/md";
import { useTranslation } from 'react-i18next';
import { PiCityLight } from "react-icons/pi";


import Account from '../Account/Account';
import Security from '../Security/Security';
import ControlPannel from '../ControlPannel/ControlPannel';
import Branding from '../Branding/Branding';


const baseTabs = [
	// {name:"Account", path:"account", value:RiAccountCircleLine},
	// {name:"Security", path:"security", value:MdOutlineSecurity},
	{ name: "Control pannel", path: "control_pannel", value: AiOutlineControl },
];

const Settings = () => {
	const { t } = useTranslation();
	const [searchParams] = useSearchParams();

	// Check if dev mode is enabled
	const isDevMode = searchParams.get('source') === 'dev';

	// Build tabs array - include Branding only in dev mode
	const tabs = isDevMode
		? [...baseTabs, { name: "Branding", path: "branding", value: MdBrush }]
		: baseTabs;

	return (
		<div className="flex gap settings_container">
			<div className="chart_section shadow settings_sidebar flex flex-col gap_5">
				{
					tabs.map((tab, index) => (
						<NavLink
							key={index}
							to={`${tab.path}${isDevMode ? '?source=dev' : ''}`}
							className={({ isActive }) => isActive ? 'flex gap w-full items-center setting_tabs setting_tab_active' : 'flex gap w-full items-center setting_tabs'}
						>
							<tab.value className="tab_icon" />
							<p className="tab_text_settings">{t(tab.name)}</p>
						</NavLink>
					))
				}
			</div>
			<div className="chart_section shadow settings_main">
				<Routes>
					{/*<Route path="/*" element={<Account/>}/>*/}
					{/*<Route path="/security" element={<Security/>}/>*/}
					<Route path="/*" element={<ControlPannel />} />
					<Route path="/branding" element={<Branding />} />
				</Routes>
			</div>
		</div>
	)
}

export default Settings